import { AsyncPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, input } from '@angular/core';

import { Observable } from 'rxjs';

import { FontIconComponent } from '@camelot/icons';
import { ButtonComponent, ErrorComponent, LoaderComponent } from '@camelot/ui';
import { CamBaseComponent, openExternalUrl } from '@camelot/utils';

@Component({
  imports: [AsyncPipe, ButtonComponent, ErrorComponent, FontIconComponent, LoaderComponent],
  selector: 'cam-tenant-url-displayer',
  templateUrl: './tenant-url-displayer.component.html',
})
export class CamTenantUrlDisplayerComponent extends CamBaseComponent {
  display = input<'button' | 'icon'>('icon');

  fetch$ = input.required<Observable<unknown>>();

  route$ = input.required<Observable<string | null>>();

  ngOnInit() {
    this.requestState.asked();
    this.fetch$().subscribe({
      complete: () => {
        this.requestState.completed();
      },
      error: (error: HttpErrorResponse) => {
        this.requestState.onError(error.status, error.statusText);
      },
    });
  }

  public navigateToTenant(url: string) {
    openExternalUrl(url);
  }
}
